import React from 'react';
import { Text } from 'react-native';
import { SlideOperationProps } from './types';
import { Flex, Swipeable } from '@kibt/meta-ui-krn';
import { HorizontalGestureConflictView } from '@/component/SpaHorizontalGestureConflictView';

export function SlideOperation(props: Partial<SlideOperationProps>) {
    const { actionWidth = 88, rightActions = [], rightActionWidth = 88, children, onOpen, onClose } = props;

    const rightWidth = rightActionWidth || actionWidth;
    return (
        <HorizontalGestureConflictView>
            <Swipeable
                animationOptions={{
                    bounciness: 0,
                    speed: 16,
                }}
                rightThreshold={rightWidth / 4}
                onClosed={onClose}
                onOpened={onOpen}
                rightWidth={rightWidth}
                rightContent={rightActions?.map((v) => {
                    return (
                        <Flex bs={{ w: rightWidth, h: '100%', bg: v.bgColor }} flex={'flexCenter'} onPress={v.onClick}>
                            {v.render ? v.render() : <Text style={[v.textStyle]}>{v.text}</Text>}
                        </Flex>
                    );
                })}
            >
                {children}
            </Swipeable>
        </HorizontalGestureConflictView>
    );
}

export default SlideOperation;
